
import React from 'react'
import SupportingDocumentsNavbar from './SupportingDocumentsNavbar';

const SupportingDocumentsLayout = ({campaign, user, children}) => {
  return (
    <div className="document-layout">
      <div className="document-layout-title">Documentos</div>
      <SupportingDocumentsNavbar campaign={campaign} user={user} />
      <div className= "document-layout-container">
        {children}
      </div>
    </div>
  )
}

export default SupportingDocumentsLayout
